import { LogReporter } from '@/common/log-report';
import BaseService from '../base';
import { IFollowRequest } from './types';

class UserService extends BaseService {
  follow(fid: number, action: number, room_id?: number) {
    const url = '/web/live/relation/follow/modify';
    const data: IFollowRequest = {
      fid,
      action,
      from_spm_id: LogReporter.getFromSpmId() || '',
      spm_id: LogReporter.getSpmId(),
      room_id,
    };
    return this.postForm(({ url, data }));
  }

  getUserInfo() {
    const url = '/intl/gateway/web/v2/user';
    return this.get({ url });
  }
}

const userService = new UserService();

export default userService;
